import { request } from '@/shared/api/request'

export const requestGrant = (body) => request({ url: `admin/request/requestGrant`, method: 'POST', params: body })